/**
 * FormAssembly js modified for multiple forms on a page.
 */

// This export statement makes this file a module, allowing global augmentation
export {};

// initialize our variables
let captchaReady = 0;
let wFORMSReady = 0;

// when wForms is loaded call this
const wformsReadyCallback = function () {
	// using this var to denote if wForms is loaded
	wFORMSReady = 1;
	// call our recaptcha function which is dependent on both
	// wForms and an async call to google
	// note the meat of this function wont fire until both
	// wFORMSReady = 1 and captchaReady = 1
	onloadCallback();
};
const gCaptchaReadyCallback = function () {
	// using this var to denote if captcha is loaded
	captchaReady = 1;
	// call our recaptcha function which is dependent on both
	// wForms and an async call to google
	// note the meat of this function wont fire until both
	// wFORMSReady = 1 and captchaReady = 1
	onloadCallback();
};

// add event listener to fire when wForms is fully loaded
document.addEventListener('wFORMSLoaded', wformsReadyCallback);

// Make form IDs unique to prevent conflicts with multiple forms
const makeFormIdsUnique = function () {
	// Find ALL form containers with data-form-id
	const formContainers = document.querySelectorAll('[data-form-id]') as NodeListOf<HTMLElement>;

	formContainers.forEach((formContainer) => {
		const formId = formContainer.dataset.formId;
		if (!formId) return;

		// Skip forms that have data-conditionals attributes populated
		const hasConditionals = formContainer.querySelector('[data-condition]');
		if (hasConditionals) {
			return;
		}

		const suffix = '_form_' + formId;
		const elementsWithIds = formContainer.querySelectorAll('[id]');
		const idMappings: { [key: string]: string } = {};

		// Create ID mappings
		elementsWithIds.forEach((element) => {
			const originalId = element.id;
			const newId = originalId + suffix;
			idMappings[originalId] = newId;
			element.id = newId;
		});

		// Update references to IDs within the form container
		Object.keys(idMappings).forEach((originalId) => {
			const newId = idMappings[originalId];

			formContainer.querySelectorAll(`[for="${originalId}"]`).forEach((label) => {
				(label as HTMLLabelElement).setAttribute('for', newId);
			});
			formContainer.querySelectorAll(`[href="#${originalId}"]`).forEach((link) => {
				(link as HTMLAnchorElement).setAttribute('href', `#${newId}`);
			});

			// Update option values that reference IDs
			formContainer.querySelectorAll(`option[value="${originalId}"]`).forEach((option) => {
				option.setAttribute('value', newId);
			});
		});
	});
};

// Wrap submit buttons in div containers for button styling
const wrapSubmitButtonsInDivs = function () {
	const submitButtons = document.querySelectorAll(
		'[id^="submit_button"]'
	) as NodeListOf<HTMLButtonElement>;

	submitButtons.forEach((submitButton) => {
		if (submitButton.parentElement?.classList.contains('submit-button-wrapper')) {
			return;
		}
		// Create wrapper div
		const wrapper = document.createElement('div');
		wrapper.className = 'submit-button-wrapper';

		if (submitButton.parentNode) {
			submitButton.parentNode.insertBefore(wrapper, submitButton);
			wrapper.appendChild(submitButton);
		}
	});
};

const enableSubmitButton = function () {
	// Find ALL submit buttons and enable them
	const submitButtons = document.querySelectorAll(
		'[id^="submit_button"]'
	) as NodeListOf<HTMLButtonElement>;
	const explanations = document.querySelectorAll('[id^="disabled-explanation"]');

	submitButtons.forEach((submitButton) => {
		submitButton.removeAttribute('disabled');
	});

	explanations.forEach((explanation) => {
		(explanation as HTMLElement).style.display = 'none';
	});
};
const disableSubmitButton = function () {
	// console.log('disableSubmitButton');
	// Find ALL submit buttons and disable them
	const submitButtons = document.querySelectorAll(
		'[id^="submit_button"]'
	) as NodeListOf<HTMLButtonElement>;
	const explanations = document.querySelectorAll('[id^="disabled-explanation"]');

	submitButtons.forEach((submitButton) => {
		submitButton.disabled = true;
	});

	explanations.forEach((explanation) => {
		(explanation as HTMLElement).style.display = 'block';
	});
};

// call this on both captcha async complete and wforms fully
// initialized since we can't be sure which will complete first
// and we need both done for this to function just check that they are
// done to fire the functionality
const onloadCallback = function () {
	// if our captcha is ready (async call completed)
	// and wFORMS is completely loaded then we are ready to add
	// the captcha to the page
	if (captchaReady && wFORMSReady) {
		// Make form IDs unique first to prevent conflicts
		makeFormIdsUnique();

		// Wrap submit buttons in div containers
		wrapSubmitButtonsInDivs();

		// Find all form containers and create reCAPTCHA for each
		const formContainers = document.querySelectorAll(
			'[data-form-id]'
		) as NodeListOf<HTMLElement>;

		formContainers.forEach((formContainer) => {
			const formId = formContainer.dataset.formId;
			if (!formId) return;

			const recaptchaId = 'g-recaptcha-render-div_form_' + formId;
			let recaptchaElement = document.getElementById(recaptchaId);

			// Ensure the reCAPTCHA element is created after a server-side validation error.
			if (!recaptchaElement) {
				const captchaContainer = document.createElement('div');
				captchaContainer.id = 'google-captcha_form_' + formId;
				captchaContainer.style.display = 'block';

				const captchaDiv = document.createElement('div');
				captchaDiv.className = 'captcha';

				const oneFieldDiv = document.createElement('div');
				oneFieldDiv.className = 'oneField';

				recaptchaElement = document.createElement('div');
				recaptchaElement.id = recaptchaId;
				recaptchaElement.className = 'g-recaptcha';

				const errorDiv = document.createElement('div');
				errorDiv.className = 'g-captcha-error';

				const helpDiv = document.createElement('div');
				helpDiv.className = 'captchaHelp';
				helpDiv.innerHTML = 'reCAPTCHA helps prevent automated form spam.<br>';

				const disabledDiv = document.createElement('div');
				disabledDiv.id = 'disabled-explanation_form_' + formId;
				disabledDiv.className = 'captchaHelp';
				disabledDiv.style.display = 'block';
				disabledDiv.innerHTML =
					'The submit button will be disabled until you complete the CAPTCHA.';

				oneFieldDiv.appendChild(recaptchaElement);
				oneFieldDiv.appendChild(errorDiv);
				oneFieldDiv.appendChild(document.createElement('br'));
				captchaDiv.appendChild(oneFieldDiv);
				captchaDiv.appendChild(helpDiv);
				captchaDiv.appendChild(disabledDiv);
				captchaContainer.appendChild(document.createElement('br'));
				captchaContainer.appendChild(captchaDiv);

				// Find the actions div and append captcha container to it
				const actionsDiv = formContainer.querySelector<HTMLDivElement>('.actions');

				if (actionsDiv) {
					actionsDiv.insertBefore(captchaContainer, actionsDiv.firstChild);
				} else {
					// Fallback: append to form container if no actions div found
					formContainer.appendChild(captchaContainer);
				}
			}
			// console.log('recaptchaId', recaptchaId);
			// Create form-specific callback function names
			const enableCallbackName = 'enableSubmitButton_form_' + formId;
			const disableCallbackName = 'disableSubmitButton_form_' + formId;

			// Create form-specific callback functions
			(window as any)[enableCallbackName] = function () {
				const submitButton = formContainer.querySelector(
					'[id^="submit_button"]'
				) as HTMLButtonElement;
				const explanation = formContainer.querySelector(
					'[id^="disabled-explanation"]'
				) as HTMLElement;

				submitButton?.removeAttribute('disabled');
				if (explanation) {
					explanation.style.display = 'none';
				}
			};

			(window as any)[disableCallbackName] = function () {
				const submitButton = formContainer.querySelector(
					'[id^="submit_button"]'
				) as HTMLButtonElement;
				const explanation = formContainer.querySelector(
					'[id^="disabled-explanation"]'
				) as HTMLElement;

				if (submitButton) {
					submitButton.disabled = true;
					if (explanation) {
						explanation.style.display = 'block';
					}
				}
			};

			// Render reCAPTCHA for this specific form with form-specific callbacks
			window.grecaptcha?.enterprise?.render(recaptchaId, {
				sitekey: '6LfMg_EaAAAAAMhDNLMlgqDChzmtYHlx1yU2y7GI',
				theme: 'light',
				size: 'normal',
				callback: enableCallbackName,
				'expired-callback': disableCallbackName,
			});

			// Disable the submit button for this form initially
			const submitButton = formContainer.querySelector(
				'[id^="submit_button"]'
			) as HTMLButtonElement;
			const explanation = formContainer.querySelector(
				'[id^="disabled-explanation"]'
			) as HTMLElement;
			if (submitButton) {
				submitButton.disabled = true;
				if (explanation) {
					explanation.style.display = 'block';
				}
			}
		});

		const oldRecaptchaCheck = parseInt('1', 10);
		if (oldRecaptchaCheck === -1) {
			const standardCaptchas = document.querySelectorAll('[id^="tfa_captcha_text"]');
			standardCaptchas.forEach((standardCaptcha) => {
				if (standardCaptcha?.parentNode?.parentNode?.parentNode) {
					const elementToRemove = standardCaptcha.parentNode.parentNode
						.parentNode as Element;
					elementToRemove.parentNode?.removeChild(elementToRemove);
				}
			});
		}

		if (!window.wFORMS?.instances?.paging) {
			const captchaElements = document.querySelectorAll('[id^="g-recaptcha-render-div"]');
			captchaElements.forEach((captchaElement) => {
				if (captchaElement?.parentNode?.parentNode?.parentNode) {
					const parentElement = captchaElement.parentNode.parentNode
						.parentNode as HTMLElement;
					parentElement.style.display = 'block';
				}
			});
		}

		// Update all captcha render divs to have the correct tfa_captcha_text IDs
		const captchaRenderDivs = document.querySelectorAll('[id^="g-recaptcha-render-div"]');
		captchaRenderDivs.forEach((captchaRenderDiv) => {
			const idAttr = captchaRenderDiv?.getAttributeNode('id');
			if (idAttr) {
				// Get the form ID from the unique ID and create the corresponding tfa_captcha_text ID
				const formIdMatch = idAttr.value.match(/_form_(\d+)$/);
				const formSuffix = formIdMatch ? '_form_' + formIdMatch[1] : '';
				idAttr.value = 'tfa_captcha_text' + formSuffix;
			}
		});
	}
};

// Make functions available globally for grecaptcha callbacks
window.enableSubmitButton = enableSubmitButton;
window.disableSubmitButton = disableSubmitButton;

// Make gCaptchaReadyCallback available globally for Google reCAPTCHA script
(window as any).gCaptchaReadyCallback = gCaptchaReadyCallback;
